(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["text-content"] && !Shopify.designMode) return;
  try {
    
// Optional JavaScript
document.addEventListener('DOMContentLoaded', function() {
  // Future enhancements
});

  } catch(e) { console.error(e); }
})();
})();
